import React, { useState } from 'react';
import {
	Button,
	Modal,
	ModalHeader,
	ModalBody,
	Form,
	Input,
	FormGroup,
	Col,
	Label,
} from 'reactstrap';
import { useSelector, useDispatch } from 'react-redux';
import { editProfile } from '../../store/actions/business';
import './index.css';
function SocialMediaEditModal(props) {
	const dispatch = useDispatch();
	const { id } = useSelector((state) => state.currentUser.user);

	const [modal, setModal] = useState(false);
	const toggle = () => setModal(!modal);

	const [facebook, setFacebook] = useState(props.valueFacebook || '');
	const [instagram, setInstagram] = useState(props.valueInstagram || '');
	const [twitter, setTwitter] = useState(props.valueTwitter || '');

	const handleSubmit = (e) => {
		e.preventDefault();
		dispatch(editProfile(id, { twitter, instagram, facebook }));
		setModal(false);
	};

	const { valueTwitter, valueInstagram, valueFacebook } = props;

	return (
		<div>
			<Button className='cta-pill-btn ml-2 mt-4' onClick={toggle}>
				<i className='nc-icon nc-settings-gear-65 mr-1' />
				Edit
			</Button>

			<Modal isOpen={modal} toggle={toggle} centered>
				<ModalHeader toggle={toggle}>
					Update your social media links
				</ModalHeader>

				<ModalBody>
					<Form onSubmit={handleSubmit}>
						<FormGroup row>
							<Label for='twitter' sm={3}>
								X
							</Label>
							<Col sm={9}>
								<Input
									type='text'
									id='twitter'
									name='twitter'
									onChange={(e) => setTwitter(e.target.value)}
									value={twitter}
									placeholder={valueTwitter || 'Add X profile URL'}
								/>
							</Col>
						</FormGroup>

						<FormGroup row>
							<Label for='instagram' sm={3}>
								Instagram
							</Label>
							<Col sm={9}>
								<Input
									type='text'
									id='instagram'
									name='instagram'
									onChange={(e) => setInstagram(e.target.value)}
									value={instagram}
									placeholder={valueInstagram || 'Add Instagram profile URL'}
								/>
							</Col>
						</FormGroup>

						<FormGroup row>
							<Label for='facebook' sm={3}>
								Facebook
							</Label>
							<Col sm={9}>
								<Input
									type='text'
									id='facebook'
									name='facebook'
									onChange={(e) => setFacebook(e.target.value)}
									value={facebook}
									placeholder={valueFacebook || 'Add Facebook page URL'}
								/>
							</Col>
						</FormGroup>

						<Button className='cta-pill-btn w-100' type='submit'>
							Save Changes
						</Button>
					</Form>
				</ModalBody>
			</Modal>
		</div>
	);
}

export default SocialMediaEditModal;
